import { onCLS, onINP, onFCP, onLCP, onTTFB, type Metric } from "web-vitals";
import { logMetric, startAutoFlush } from "./collector";

function mapMetric(metric: Metric) {
  return {
    type: "web-vital",
    name: metric.name,
    value: metric.value,
    timestamp: Date.now(),
    extra: { id: metric.id, delta: (metric as any).delta },
  };
}

export function reportWebVitals() {
  const onReport = (m: Metric) => {
    try {
      const metric = mapMetric(m);
      try {
        console.debug("[perf] web-vital reported", metric);
      } catch {}
      logMetric(metric);
    } catch (e) {
      try {
        console.debug("[perf] web-vitals onReport error", e);
      } catch {}
      // ignore errors in telemetry
    }
  };

  onCLS(onReport);
  onINP(onReport);
  onFCP(onReport);
  onLCP(onReport);
  onTTFB(onReport);

  // ensure periodic flush is scheduled
  startAutoFlush();
}
